import { EEnvironment, envVars, type IAssetSchema } from '@/config';
import { bytesToMB } from './array';
import { ClientStorage } from './clientStorage';

export async function getImageInfo(url: string) {
  const img = new Image();
  img.src = url;

  // resolution
  const resolution = await new Promise<{ w: number; h: number }>((res, rej) => {
    img.onload = () => res({ w: img.naturalWidth, h: img.naturalHeight });
    img.onerror = rej;
  });

  // size
  const bytes = await fetch(url)
    .then((r) => r.blob())
    .then((b) => b.size);

  return { size: bytesToMB(bytes), width: resolution.w, height: resolution.h };
}

export const injectAssetTags = (
  text: string | null,
  assets: Array<Pick<IAssetSchema, 'picture' | 'index'>>,
  preset: 'original' | 'medium' | 'large' = 'original',
): string => {
  // check if source is empty
  if (!text) {
    return '';
  }

  // check if assets is empty
  if (!assets?.length) {
    return text;
  }

  // check if source has tags
  const hasTags = /\[(lightgallery){1}[0-9]{0,}\]/i.test(text);
  if (!hasTags) {
    return text;
  }

  const savedEnv = ClientStorage.local.getItem<EEnvironment>('ques-envMode') || EEnvironment.PRODUCTION;
  const bucket = savedEnv === EEnvironment.PRODUCTION ? envVars.aws.bucket : envVars.aws.devBucket;
  const prefix = `${envVars.aws.s3Url}/${bucket}`;

  // let newText = text;
  // for (const asset of assets) {
  //   const index = asset.index ?? 0;
  //   const tag = `[lightgallery${index}]`;
  //   const metadata = JSON.stringify({
  //     caption: asset.picture.caption || '',
  //     sensitive: asset.picture.sensitive,
  //     path: asset.picture.path,
  //     path256: asset.picture.path256,
  //     path512: asset.picture.path512,
  //     name: asset.picture.name,
  //     overlayPath: asset.picture.overlayPath,
  //     overlayPath256: asset.picture.overlayPath256,
  //     overlayPath512: asset.picture.overlayPath512,
  //     thumbhash: asset.picture.thumbhash,
  //   });

  //   newText = newText.replace(tag, `\n![${metadata}](${asset.picture.path})\n`);
  // }

  // parse text and replace lightgallery tags with asset metadata
  const parsedText = text.replace(/\[lightgallery(\d*)\]/g, (match, idxStr) => {
    const index = idxStr ? Number(idxStr) : 0;
    const asset = assets.find((a) => a.index === index);
    if (!asset) return match;

    const getPath = (p?: string) => (p ? `${prefix}/${p.replace('images/', '')}` : undefined);

    const { picture } = asset;
    const metadata = JSON.stringify({
      ...picture,
      path: getPath(picture.path),
      path256: getPath(picture.path256),
      path512: getPath(picture.path512),
      overlayPath: picture.overlayPath ? getPath(picture.overlayPath) : undefined,
      overlayPath256: picture.overlayPath256 ? getPath(picture.overlayPath256) : undefined,
      overlayPath512: picture.overlayPath512 ? getPath(picture.overlayPath512) : undefined,
    });

    const paths = {
      original: picture.path,
      medium: picture.path256,
      large: picture.path512,
    };

    return `\n![${metadata}](${getPath(paths[preset])})\n`;
  });

  return parsedText;
};
